/* eslint-disable i18next/no-literal-string */

import { AndroidTVAppLink } from './links';

export const appsContent = {
  title: 'Last ned vår nye VGTV-app',
  tabs: [
    {
      label: 'Android TV',
      content: (
        <>
          <div>
            Du kan bruke VGTV-appen på Android-TV som bruker Android 7 eller
            nyere.
          </div>
          <div>
            Søk på VGTV i Google play-butikken og last appen ned til din TV. Du
            må være innlogget på samme google-bruker som på din TV, for å kunne
            laste ned appen fra web.
          </div>
          <div>
            <AndroidTVAppLink />
          </div>
        </>
      ),
    },
    {
      label: 'Samsung Smart TV',
      content: (
        <>
          <div>
            Vi har dessverre ikke tilgjengelig app på Samsung Smart TV-er ennå.
            Vi anbefaler å koble til TV-en via tilleggsutstyr som Chromecast,
            Google TV eller Apple TV. Eventuelt direkte gjennom Airplay til din
            Samsung TV.
          </div>
          <div>Du vil finne alternative tilkoblinger lenger ned på siden.</div>
        </>
      ),
    },
    {
      label: 'LG Smart TV',
      content: (
        <>
          <div>
            Vi har dessverre ikke tilgjengelig app på LG Smart TV-er ennå. Vi
            anbefaler å koble til TV-en via tilleggsutstyr som Chromecast,
            Google TV eller Apple TV. Eventuelt direkte gjennom Airplay til din
            LG Smart TV.
          </div>
          <div>Du vil finne alternative tilkoblinger lenger ned på siden.</div>
        </>
      ),
    },
  ],
};
